<template>
    <div id="incode-container"></div>
</template>

<script>
import servicios from "../../../servicios/service.js";
import { 
    enviarDatosProspectoBuroCredito,
    getSession, 
    obtenerDatosProspectoBuroCredito, 
    obtenerProspectoRepresentanteLegal, 
    saveSession, 
    updateSession,
    ObtenerAutorizacionBuroApi,
    ProspectoTieneArchivoBuroCredito
} from '../../../apiConnection/api_client';
/* API DEMO Incode*/
const API_URL = process.env.VUE_APP_URL_API_INCODE;
const CLIENT_ID = process.env.VUE_APP_CLIENTID_INCODE;
const flow_Id = process.env.VUE_APP_FLOWID_INCODE;
const transaction_Id = process.env.VUE_APP_TRANSACTIONID_INCODE;
/* Session vars */
let userOnBoarding = null;
let createSession = null;
let userSession = null;
let prevSession = null;
let container = null;

export default {
    name: "IntegracionExpedienteIncodeV2",
    data() {
        return {
            prospectoId: this.$store.getters.prospectoId,
            tipoPersona: this.$store.getters.tipoPersona,
            datosPersonales: null,
            idType: this.$store.getters.getseleccionDocument == 'INE/IFE' ? 'front' : 'passport',
            consultaBuroAutorizada: false,
            tieneArchivoBuroCredito: false,
            OnboardingErrorMessage: {
                ID: this.esExtranjero()
                    ? 'Oops, an error occurred while scanning your ID. Please reload the page to try again.'
                    : 'Ups, hubo un error al escanear tu identificación. Por favor, recarga la página para intentarlo nuevamente.',
                SELFIE: this.esExtranjero()
                    ? "Oops, something went wrong while processing your selfie. Please try again."
                    : "Ups, algo salió mal al procesar tu selfie. Por favor, inténtalo nuevamente.",
                SIGNATURE: this.esExtranjero()
                    ? "Oops, there was an issue with your signature. Please try again."
                    : "Ups, hubo un problema con tu firma. Por favor, inténtalo nuevamente.",
                SESSION: this.esExtranjero()
                    ? "Sorry, we couldn't verify your identity. Please reload the page and try again."
                    : "Lo siento, no se pudo validar tu identidad. Por favor, recarga la página e inténtalo nuevamente."
            }
        }
    },
    async mounted() {
        this.ocultarHeader();
        container = document.getElementById('incode-container');
        /* Set onboarding enviroment */
        await this.initProspectoRepresentanteLegal();
        await this.prospectoTieneArchivoBuroCredito();
        await this.retrievePreviousSession();
        userOnBoarding = await this.createOnboarding();
        if(prevSession) {
            if(prevSession.finishStatus == 'COMPLETE') {
                this.goToIntegracionExpediente();
                return;
            }
            createSession = () => {
                return userOnBoarding.createSession('ALL',null, {
                    interviewId: prevSession.interviewId,
                    configurationId: flow_Id,
                    externalId: transaction_Id,
                })
            }
            
        } else {
            createSession = () => {
                return userOnBoarding.createSession('ALL',null, {
                    configurationId: flow_Id,
                    externalId: transaction_Id,
                })
            }
        }
        await this.startOnboarding();
    },
    methods: {
        /* Incode */
        ocultarHeader() {
            servicios.OnboardingOnProgress(true);
        },
        async createOnboarding() {
            const apiURL = API_URL;
            const clientId = CLIENT_ID;
            return window.OnBoarding.create({
                clientId: clientId,
                apiURL: apiURL,
                lang: this.esExtranjero() ? 'en' : 'es',
                theme: {
                    mainButton: {
                        borderRadius: "0",
                    }
                }
            });
        },
        async startOnboarding() {
            await userOnBoarding.warmup();
            userSession = await createSession();
            console.log(userSession); // Sesion validada
            if (!prevSession) await this.saveNewSession();
            await this.scanFrontSideIdentification();
        },        
        async retrievePreviousSession() {
            try {
                const session = await getSession(this.prospectoId);
                prevSession = session;
            } catch (_) {
                prevSession = null;
                this.$router.push({ name: 'ErrorOnBoarding'});
            }
        },
        async saveNewSession() {
            try {
                let session = {
                    prospectoId: this.prospectoId.toString(),
                    token: userSession.token,
                    interviewCode: userSession.interviewCode,
                    interviewId: userSession.interviewId,
                    flowType: userSession.flowType,
                    finishStatus: 'INCOMPLETE'
                };
                await saveSession(session);
            } catch(e) {
                this.$router.push({ name: 'ErrorOnBoarding'});
            }  
        },
        async updateUserSession() {
            try {
                await updateSession(this.prospectoId)
            } catch(e) {
                console.log(e);
            }
        },
        async scanFrontSideIdentification() {
            console.log(this.idType);
            userOnBoarding.renderCamera(this.idType, container, {
                onSuccess: async () => {
                    if(this.idType == 'front') {
                        await this.scanBackSideIdentification();
                    } else {
                        await this.processIdentification();
                    }
                },
                onError: () => {
                    this.$router.push({ name: 'ErrorOnBoarding'});
                },
                token: userSession,
                showTutorial: true,
                numberOfTries: 3,
            });
        },
        async scanBackSideIdentification() {
            userOnBoarding.renderCamera('back', container, {
                onSuccess: async () => {
                    await this.processIdentification();
                },
                onError: () => {
                    this.$router.push({ name: 'ErrorOnBoarding'});
                },
                token: userSession,
                showTutorial: true,
                numberOfTries: 3,
            });
        },
        async processIdentification() {
            await userOnBoarding.processId({ token: userSession.token });
            await this.takeSelfie();
        },
        async takeSelfie() {
            userOnBoarding.renderCamera('selfie', container, {
                onSuccess: async () => {
                    await this.renderSignatureCanva();
                },
                onError: () => {
                    this.$router.push({ name: 'ErrorOnBoarding'});
                },
                token: userSession,
                showTutorial: true,
                numberOfTries: 3,
                noWait: true,
            });
        },
        async renderSignatureCanva() {
            userOnBoarding.renderSignature(container, {
                onSuccess: async () => {
                    const { action } = await userOnBoarding.getFinishStatus(flow_Id, {
                        token: userSession.token,
                    });
                    if (action == 'approved' || action == 'none') {
                        await this.updateUserSession();
                        if(!this.esExtranjero()) {
                            await this.procesarDatosBuroCredito();
                        }
                        this.goToIntegracionExpediente();
                    } else {
                        this.$router.push({ name: 'ErrorOnBoarding'});
                    }
                },
                onError: () => {
                    this.AlertaEmbajadores(this.OnboardingErrorMessage.SIGNATURE, true, !this.esExtranjero());
                },
                token: userSession.token,
            });
        },
        goToIntegracionExpediente() {
            if(this.tipoPersona == 1) {
                this.$router.push({
                    name: "IntegracionExpedienteMoral",
                });
            } else {
                this.$router.push({name:this.$store.state.goToSinOnboarding.to});
            }
        },
        async loadOnboardingScreen() {
            await userOnBoarding.sendGeolocation({ token: userSession.token });
        },
        /* Another methods */
        async initProspectoRepresentanteLegal() {
                if(this.tipoPersona == 1){
                    const representanteLegalId = await obtenerProspectoRepresentanteLegal(this.prospectoId);
                    this.prospectoId = representanteLegalId;
                } else {
                    this.prospectoId = this.$store.getters.prospectoId;
                }
        },
        async procesarDatosBuroCredito() {
            try {
                const { data } =  await obtenerDatosProspectoBuroCredito(this.prospectoId);
                if(data) {
                    await enviarDatosProspectoBuroCredito(this.prospectoId);
                }
            } catch(_) {
                this.goToIntegracionExpediente();
            }
        },
        async ObtenerAutorizacionBuro() {
            const { data } =  await ObtenerAutorizacionBuroApi(this.prospectoId);
            const { tieneDocumento } = data;
            this.consultaBuroAutorizada = tieneDocumento;
        },
        esExtranjero() {
            return servicios.esExtranjero(this.$store.getters.tipoPersona);
        },
        async prospectoTieneArchivoBuroCredito() {
            const { data }  =  await ProspectoTieneArchivoBuroCredito(this.prospectoId);
            this.tieneArchivoBuroCredito = data;
        }
    }
}
</script>

<style scoped >
.IncodeTutorialHeaderTitle {
    color: #1e2120 !important;
}
.IncodeTutorialHeaderContainerselfie h1, span {
    color: #1e2120 !important;
}
</style>